import { motion } from "framer-motion";
import { Users, Scale, Calculator } from "lucide-react";

const LEGAL_IMG =
  "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxsZWdhbCUyMGRvY3VtZW50cyUyMGxhdyUyMGp1c3RpY2V8ZW58MHx8fHwxNzg2NTU0MTk3fDA&ixlib=rb-4.1.0&q=85";

const services = [
  {
    icon: Users,
    title: "Gestión de Recursos Humanos",
    points: ["Elaboración de Planillas de Pago", "Envío de Comprobantes de Pago", "Planillas CCSS", "Planillas INS", "Apoyo en contratación y despidos", "Control de Vacaciones", "Cálculo de Aguinaldos", "Entre otros"],
  },
  {
    icon: Scale,
    title: "Asesoría Legal Laboral",
    points: ["Cumplimiento de normativa vigente", "Prevención de conflictos", "Redacción de contratos", "Representación administrativa y judicial", "Revisión de Documentos para trámites", "Entre otros"],
  },
  {
    icon: Calculator,
    title: "Contabilidad",
    points: ["Contabilidad Tributaria", "Detalle de ingresos y gastos contable", "Controles Bancarios", "Asesoría personalizada de Proyectos", "Estados Financieros anuales", "Flujos proyectados", "Entre otros"],
  },
];

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

export const Servicios = () => {
  return (
    <section id="servicios" className="relative py-28 sm:py-36 bg-vnavy-800 grain overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-vteal-light" />
            <span className="text-sm uppercase tracking-[0.3em] text-vteal-light font-semibold">Servicios</span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight text-white leading-tight">
            Un paquete integral de servicios, tres pilares estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                custom={i}
                variants={fade}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                data-testid={`service-card-${i}`}
                className="relative rounded-2xl bg-vnavy border border-white/10 p-8 hover:border-vteal-light/40 transition-colors duration-500 group"
              >
                <div className="h-14 w-14 rounded-xl bg-vteal/15 flex items-center justify-center mb-6 group-hover:bg-vteal/25 transition-colors">
                  <Icon className="h-7 w-7 text-vteal-light" />
                </div>
                <h3 className="font-serif text-2xl text-white mb-5">{s.title}</h3>
                <ul className="space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-gray-400 text-sm leading-relaxed">
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-vteal-light shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mt-8 relative rounded-2xl overflow-hidden border border-white/10 min-h-[220px] flex items-center"
        >
          <img src={LEGAL_IMG} alt="Justicia y ley" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-vnavy via-vnavy/85 to-transparent" />
          <div className="relative z-10 p-10 sm:p-14 max-w-2xl">
            <p className="font-serif text-2xl sm:text-3xl text-white leading-snug">
              Al centralizar estos tres servicios en un solo proveedor, su empresa obtiene mayor eficiencia, menos riesgos y un ahorro real.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
